import { render, staticRenderFns } from "./supplier-detail-quoted-history.vue?vue&type=template&id=21c006cc&scoped=true&"
import script from "./supplier-detail-quoted-history.vue?vue&type=script&lang=js&"
export * from "./supplier-detail-quoted-history.vue?vue&type=script&lang=js&"
import style0 from "./supplier-detail-quoted-history.vue?vue&type=style&index=0&id=21c006cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c006cc",
  null
  
)

export default component.exports